export default "__VITE_ASSET__C5UhKD____"